import type { WavespeedModelConfig, StatusMapping } from './types';
import { upscalerConfigs } from './configs/upscaler';
import { wavespeedToolConfigs } from './configs/wavespeed';
import { ltxConfigs } from './configs/ltx';
import { openaiConfigs } from './configs/openai';
import { heygenConfigs } from './configs/heygen';
import { bytedanceConfigs } from './configs/bytedance';
import { nvidiaConfigs } from './configs/nvidia';
import { lumaConfigs } from './configs/luma';
import { skyworkConfigs } from './configs/skywork';
import { klingConfigs } from './configs/kling';
import { googleConfigs } from './configs/google';
import { blackForestLabsConfigs } from './configs/black-forest-labs';
import { minimaxConfigs } from './configs/minimax';

/**
 * Wavespeed 状态映射配置（所有模型统一使用）
 */
export const wavespeedStatusMapping: StatusMapping = {
    /** 任务 ID 字段路径 */
    taskIdPath: 'data.id',
    /** 状态字段路径 */
    statePath: 'data.status',
    /** 成功状态值 */
    success: ['success', 'completed'],
    /** 失败状态值 */
    failed: ['fail', 'failed'],
    /** 处理中状态值 */
    processing: ['created', 'queueing', 'processing'],
    /** 视频 URL 字段路径 */
    videoUrlPath: 'data.outputs[0]',
    /** 错误信息字段路径 */
    errorPath: 'data.error',
};

/**
 * 模型配置映射
 */
export const wavespeedModelConfigs: Record<string, WavespeedModelConfig> = {
    ...upscalerConfigs,
    ...wavespeedToolConfigs,
    ...ltxConfigs,
    ...openaiConfigs,
    ...heygenConfigs,
    ...bytedanceConfigs,
    ...nvidiaConfigs,
    ...lumaConfigs,
    ...skyworkConfigs,
    ...klingConfigs,
    ...googleConfigs,
    ...blackForestLabsConfigs,
    ...minimaxConfigs,
};